export const MICRO_SERVICE_MAPPER = {
  "static-data": ["lookups", "lookupsData", "lookupsLang"],
  site: [
    "sites",
    "devices",
    "userSites",
    "siteForms",
    "siteDevices",
    "userSites/delete",
    "locations",
    "siteLocations",
    "locationDevices",
  ],
  security: ["userAccounts", "userPermissions"],
  forms: ["definitions", "users", "siteForms", "sections", "formUsers"],
  email: ["emailConfigs"],
  notification: ["events"],
};

export function createMicroServiceURL(entity: string) {
  const service = Object.keys(MICRO_SERVICE_MAPPER).find((key) =>
    MICRO_SERVICE_MAPPER[key].includes(entity)
  );
  return `${service}/${entity}`;
}
